const SCROLL_ANIMATION_TRIGGER_CLASSNAME = "scroll-trigger";
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = "scroll-trigger--offscreen";
const VISIBLE_CLASS = "scroll-trigger--visible";

let scrollAnimationObserver = null;

function isDesignMode() {
	return typeof Shopify !== "undefined" && Shopify.designMode;
}

function revealElement(element) {
	if (!element) return;
	element.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
	element.classList.add(VISIBLE_CLASS);
}

function calculateOrders(rootEl) {
	const scope = rootEl && rootEl.querySelectorAll ? rootEl : document;
	const sections = scope.querySelectorAll("section");

	sections.forEach((section) => {
		const cascadeItems = section.querySelectorAll(
			"." + SCROLL_ANIMATION_TRIGGER_CLASSNAME + "[data-cascade]"
		);

		cascadeItems.forEach((element, index) => {
			if (element.classList.contains("collection-tab-product-card")) return;
			element.style.setProperty("--animation-order", String(index));
		});
	});
}

function onIntersection(entries, observer) {
	entries.forEach((entry) => {
		if (!entry.isIntersecting) return;
		revealElement(entry.target);
		observer.unobserve(entry.target);
	});
}

function initializeScrollAnimationTrigger(
	rootEl = document,
	isDesignModeEvent = false
) {
	const scope =
		rootEl && rootEl.getElementsByClassName ? rootEl : document;
	const animationTriggerElements = Array.from(
		scope.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME)
	);

	if (animationTriggerElements.length === 0) return;

	calculateOrders(scope);

	// Theme editor: show content immediately, never run observers / debugger loops
	if (isDesignModeEvent || isDesignMode()) {
		animationTriggerElements.forEach((element) => {
			element.classList.add("scroll-trigger--design-mode");
			revealElement(element);
		});
		return;
	}

	if (typeof IntersectionObserver === "undefined") {
		animationTriggerElements.forEach((element) => revealElement(element));
		return;
	}

	if (!scrollAnimationObserver) {
		scrollAnimationObserver = new IntersectionObserver(onIntersection, {
			rootMargin: "0px 0px -40px 0px",
			threshold: 0,
		});
	}

	animationTriggerElements.forEach((element) => {
		if (element.classList.contains(VISIBLE_CLASS)) return;
		scrollAnimationObserver.observe(element);
	});
}

window.addEventListener("DOMContentLoaded", () => {
	initializeScrollAnimationTrigger();
});

document.addEventListener("shopify:section:load", (event) => {
	initializeScrollAnimationTrigger(event.target, isDesignMode());
});

if (typeof Shopify !== "undefined" && Shopify.designMode) {
	document.addEventListener("shopify:section:reorder", () => {
		initializeScrollAnimationTrigger(document, true);
	});
}
